import { mapState, mapMutations } from 'vuex';
import { validationFormMixin } from '../../../../modules/shared/mixins/validationFormMixin';
import {
  fetchTaxes,
  createTax,
  updateTax,
  deleteTax,
} from '../../helpers/KnProductsOption';
import KnFormSubtitle from '../../../shared/components/KnFormSubtitle/KnFormSubtitle.vue';
import KnFormActionButtons from '../../../shared/components/KnFormActionButtons/KnFormActionButtons.vue';
import KnTextField from '../../../shared/components/KnTextField.vue';
import { paginationMixin } from '@/modules/shared/mixins/paginationMixin';
import KnPagination from '../../../shared/components/KnPagination.vue';

export default {
  components: {
    KnFormSubtitle,
    KnFormActionButtons,
    KnTextField,
    KnPagination,
  },
  mixins: [paginationMixin, validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      tax: {
        id: 'NA', // No asignado
        nombre_impuesto: null,
        valor_impuesto: null,
        id_autor: null,
        id_institucion_educativa: null,
      },
      taxes: [],
      toUpdate: false,
      showInactive: false,
      loading: false,
    };
  },
  async created() {
    this.setIsLogin(false);
    await this.getPaginatedTaxes(1);
    this.tax.id_autor = this.userData.id;
    this.tax.id_institucion_educativa = this.institutionId;
    //this.taxes = await fetchTaxesEI(this.institutionId)//this.fetchResultsByEI('productos', 'impuesto', this.institutionId)
  },
  watch: {
    institutionId: {
      async handler() {
        this.setIsLogin(false);
        await this.getPaginatedTaxes(1);
        this.tax.id_autor = this.userData.id;
        this.tax.id_institucion_educativa = this.institutionId;
      },
    },
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Crear';
    },
    invalidFields() {
      return this.objectHasNulls(this.tax);
    },
  },

  methods: {
    ...mapMutations(['setIsLogin']),
    async getPaginatedTaxes(page = 1) {
      try {
        this.taxes = [];
        this.setPaginationPage(page);

        if (!this.loading) {
          this.loading = true;

          const { ok, data, message, count } = await fetchTaxes({
            institutionId: this.institutionId,
            systemStatus: !this.showInactive,
            limit: this.pagination.limit,
            offset: this.pagination.offset,
          });

          if (ok) {
            this.setPaginationCount(count);
            for (const tax of data) {
              this.taxes.push({ ...tax });
            }
          } else {
            console.error('No se pudieron obtener los impuestos', message);
          }

          this.loading = false;
        }
      } catch (error) {
        console.error('Error al obtener los impuestos:', error);
        this.loading = false;
      }
    },
    async save() {
      if (this.toUpdate) {
        await updateTax(
          this.tax.id,
          this.tax.nombre_impuesto,
          this.tax.valor_impuesto,
          this.tax.id_institucion_educativa,
          this.tax.id_autor
        );
        this.toUpdate = false;
        await this.getPaginatedTaxes(1);
      } else {
        await createTax(
          this.tax.nombre_impuesto,
          this.tax.valor_impuesto,
          this.tax.id_institucion_educativa,
          this.tax.id_autor
        );
        this.clear();
        await this.getPaginatedTaxes(1);
      }
      this.clear();
    },
    clear() {
      this.tax = {
        id: 'NA', // No asignado
        nombre_impuesto: null,
        valor_impuesto: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    clearInline() {
      this.tax = {
        id: 'NA', // No asignado
        nombre_impuesto: null,
        valor_impuesto: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    edit(item) {
      this.tax = { ...item };
      this.tax.valor_impuesto = item.valor_impuesto * 100;
      this.tax.id_institucion_educativa = item.institucion_educativa.id;
      this.toUpdate = true;
    },
    async deleteInline(itemId) {
      await deleteTax(itemId);
      await this.getPaginatedTaxes(1);
      this.clearInline();
    },
  },
};
